import AboutUs from "../Components/AboutUs";
import HeroSlider from "../Components/HeroSlider";
import BrandSection from "../Components/OurBrands";
import ProductSlider from "../Components/ProductSlider";

function Home() {
  return (
    <div className="Home">
      <HeroSlider />
       <BrandSection />
       <AboutUs />
       <ProductSlider />
    </div>
  );
}

export default Home;